import * as React from 'react';
import type { SVGProps } from 'react';

const IconDeepResearchSmallI = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22" {...props}>
      <path
        d="M.803 5.29H.556V.033h15.062v5.255h-4.562c-.261 0-.262 0-.262.261V16.141c-.093-.042-.152-.064-.207-.095-1.673-.97-3.346-1.94-5.021-2.905-.142-.082-.186-.175-.185-.333.005-2.404.004-4.808.003-7.212 0-.343.027-.305-.296-.305-1.429-.002-2.857 0-4.285 0v-.002ZM.556 16.66v5.24h15.062v-5.24H.556Z"
        fill="#F32A52"
      />
      <path
        d="M20.785 17.136c.26 0 .455-.216.455-.454a5.583 5.583 0 0 1 5.584-5.583c.26 0 .454-.216.454-.454a.472.472 0 0 0-.454-.455c-3.074 0-5.584-2.51-5.584-5.582a.457.457 0 0 0-.455-.455.472.472 0 0 0-.454.455 5.583 5.583 0 0 1-5.585 5.582.457.457 0 0 0-.454.455c0 .238.216.454.454.454a5.583 5.583 0 0 1 5.585 5.583c0 .26.216.454.454.454ZM27.28 8.273a.29.29 0 0 0 .288-.289 3.543 3.543 0 0 1 3.544-3.542.29.29 0 0 0 .288-.289.3.3 0 0 0-.288-.288A3.552 3.552 0 0 1 27.568.322a.29.29 0 0 0-.288-.288.3.3 0 0 0-.289.288 3.543 3.543 0 0 1-3.543 3.543.29.29 0 0 0-.289.288.3.3 0 0 0 .289.289 3.543 3.543 0 0 1 3.543 3.542.29.29 0 0 0 .289.289Z"
        fill="#C5A26D"
      />
    </svg>
  );
};
export default IconDeepResearchSmallI;
